module.exports = __webpack_public_path__ + "img/model9_ug.671f125e.png";